import { Check, X } from 'lucide-react';
import { Button, Card, CardTitle, Chip } from '@/ui/primitives';
import { Stack } from '@/ui/layout';
import { useDeepHealth } from '../api';

const SERVICE_LABELS: Record<string, string> = {
  postgres: 'PostgreSQL',
  redis: 'Redis',
  qdrant: 'Qdrant',
  litellm: 'LiteLLM',
};

export function HealthCheckPanel() {
  const deep = useDeepHealth();

  return (
    <Card padding="lg">
      <Stack gap="md">
        <div className="flex items-center justify-between">
          <CardTitle>Saúde de dependências</CardTitle>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => deep.mutate()}
            disabled={deep.isPending}
          >
            {deep.isPending ? 'Verificando…' : 'Rodar verificação'}
          </Button>
        </div>

        {deep.error && (
          <p className="text-xs text-danger">Falha ao executar verificação profunda.</p>
        )}

        {deep.data ? (
          <ul className="flex flex-col divide-y divide-border">
            {Object.entries(deep.data.checks).map(([name, check]) => (
              <li key={name} className="py-2.5 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 min-w-0">
                  {check.ok ? (
                    <Check size={14} strokeWidth={2} className="text-ok shrink-0" />
                  ) : (
                    <X size={14} strokeWidth={2} className="text-danger shrink-0" />
                  )}
                  <span className="text-sm text-text">{SERVICE_LABELS[name] ?? name}</span>
                </div>
                <div className="flex items-center gap-2">
                  {check.latency_ms !== undefined && (
                    <Chip tone="neutral" size="sm">
                      {check.latency_ms} ms
                    </Chip>
                  )}
                  {check.error && (
                    <span className="text-xs text-danger truncate max-w-[200px]">
                      {check.error}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-xs text-text-muted">
            Clique em &quot;Rodar verificação&quot; para checar PostgreSQL, Redis e Qdrant.
          </p>
        )}
      </Stack>
    </Card>
  );
}
